/**
 * Adapptio Integration extensions base library.
 *
 * @package ext-integrations-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IAppClient } from "@adapptio/lib-core";

export const registerExtension = ( app: IAppClient ) => {
	//
};